import * as React from 'react';
import {SFC} from 'react';
import './styles.sass';

export const JobsHeader: SFC<{}> = () => (
  <div className={'jobs-header'}>
    <h2 className={'jobs-header__sub-title'}>Join us in helping amazing people unlock their potential</h2>
    <h1 className={'jobs-header__title'}>Starting with Yours</h1>
  </div>
);
